import { render } from "./changePasswordComponent.vue?vue&type=template&id=558fa3e4&scoped=true"
import script from "./changePasswordComponent.vue?vue&type=script&lang=js"
export * from "./changePasswordComponent.vue?vue&type=script&lang=js"

import "./changePasswordComponent.vue?vue&type=style&index=0&id=558fa3e4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-558fa3e4"]])

export default __exports__